export default function StatusBadge({ status }) {
  const value = String(status || "unknown").toLowerCase();
  const isWarning =
    value.includes("disable") ||
    value.includes("expired") ||
    value.includes("high");
  const isAttention =
    value.includes("ending") ||
    value.includes("expiring") ||
    value.includes("medium") ||
    value.includes("soon");
  const isActive =
    value.includes("active") ||
    value.includes("ready") ||
    value.includes("healthy") ||
    value.includes("enabled") ||
    value.includes("low");

  return (
    <span
      className={`tw-inline-flex tw-items-center tw-rounded-full tw-px-3 tw-py-1 tw-text-xs tw-font-medium ${
        isWarning
          ? "tw-bg-[rgba(243,86,88,0.12)] tw-text-[#C44749]"
          : isAttention
          ? "tw-bg-[rgba(250,216,69,0.22)] tw-text-[#8B6A00]"
          : isActive
          ? "tw-bg-[rgba(250,216,69,0.18)] tw-text-[#2C3255]"
          : "tw-bg-[rgba(44,50,85,0.08)] tw-text-[#5E6786]"
      }`}
    >
      {status || "unknown"}
    </span>
  );
}
